import { CricketController } from "./cricketController";
import { NormalGameController } from "./normalGameController";
import { CRICKET_GAME, CRICKET_CUT_GAME } from "../../../config/games";

export const REDUCER = (accumulator, currentValue) =>
  accumulator + currentValue;
export class ScoreController {
  constructor(gameType, state, scoreTotal) {
    console.log("---------> gametype:", gameType);
    this.state = state;
    this.scoreTotal = scoreTotal;
    if (gameType === CRICKET_GAME) {
      this.controller = CricketController;
    } else if (gameType === CRICKET_CUT_GAME) {
      this.controller = CricketController;
    } else {
      this.controller = NormalGameController;
    }
  }

  calculateScores(state, value, multiple) {
    const { currentRound, players, scoreMultiplier } = state;

    const score = value * multiple;

    // On ajoute le score dans le currentRound
    currentRound.scores.push(score);
    const scoreTotal = currentRound.scores.reduce(REDUCER);
    const detail = this.controller.calculateScores(
      value,
      multiple,
      currentRound,
      players,
      scoreMultiplier,
      scoreTotal
    );

    detail.currentRound.cricket[value] = currentRound.cricket[value] + multiple;

    return {
      ...detail,
      total: detail.scoreTotal,
      currentRound: {
        ...currentRound,
        darts: currentRound.scores.length,
      },
    };
  }

  isWinner(updatedPlayers, updatedPlayer) {
    return this.controller.isWinner(updatedPlayers, updatedPlayer)
  } 
}
